module.exports = __webpack_public_path__ + "img/kelvin-pro.a883c7dc.jpg";